import type { NextRequest } from "@/modules/fetch/types"
import type { FooterLink } from "@/modules/headerFooterFO/Footer/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

type GetFooterLinksParams = {
  locale: I18nLocale
  req?: NextRequest
}

const FOOTER_LINKS_ENDPOINT = "/jobteaser.contentmanagement.v1alpha1/DedicatedHomePageService/ListDedicatedHomePages"

export const getFooterLinks = async (params: GetFooterLinksParams): Promise<FooterLink[]> => {
  const { locale, req } = params

  return fetcher(FOOTER_LINKS_ENDPOINT, {
    nextRequest: req,
    requestInit: {
      body: JSON.stringify({ page: 1, page_size: 5 }),
      headers: {
        "Accept-Language": locale,
      },
      method: "POST",
    },
    serviceDomain: "GATEWAY_API",
  })
    .then(
      getResultFromResponse<FooterLink[]>({
        transformResult: result => toCamelCaseKeys<{ pageInfos: FooterLink[] }>(result).pageInfos,
      })
    )
    .catch(handleFetchError(FOOTER_LINKS_ENDPOINT))
}
